<template>
  <div>
    <b-card-header>
      <b-row>
        <b-col class="col-sm-10">
          <h3 class="mb-0">Patient Memberships</h3>
        </b-col>
        <b-col style="text-align: right"> </b-col>
      </b-row>
    </b-card-header>

    <el-table
      id="paymentPlanTable"
      class="table-responsive table-flush hover"
      header-row-class-name="thead-light"
      :data="paymentPlans"
      type="selection"
      @row-click="handleClick"
      hover
      @sort-change="sortChange"
    >
      <el-table-column
        label="Created"
        prop="Created"
        min-width="75px"
        sortable="custom"
      >
        <template v-slot="{ row }">
          {{ row.created | moment("MM/DD/YYYY") }}<br />
          <small>{{ row.created | moment("hh:mm:ss A") }}</small>
        </template>
      </el-table-column>

      <el-table-column
        label="Patient"
        min-width="100px"
        sortable="custom"
        prop="LastName"
        v-if="!supressPatientName"
      >
        <template v-slot="{ row }">
          {{ row.customerName }}<br />
          <small class="text-muted">{{ row.customerEmail }}</small>
        </template>
      </el-table-column>

      <el-table-column
        label="Start Date"
        prop="StartDate"
        min-width="75px"
        sortable="custom"
      >
        <template v-slot="{ row }">
          <div
            v-if="
              row.status != 'AWAITINGPATIENT' ||
                new Date(row.startDate) > new Date()
            "
          >
            {{ row.startDate | moment("MM/DD/YYYY") }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        label="Next Payment"
        prop="NextBillingDate"
        min-width="95px"
        sortable="custom"
      >
        <template v-slot="{ row }">
          <div v-if="row.status != 'AWAITINGPATIENT'">
            {{ row.nextBillingDate | moment("MM/DD/YYYY") }}<br />
            <small class="text-muted">{{ row.cycle | title }}</small>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        label="Membership Amount"
        prop="Amount"
        min-width="90px"
        sortable="custom"
      >
        <template v-slot="{ row }">
          {{ (row.amount / 100) | currency }}
        </template>
      </el-table-column>

      <el-table-column
        label="Past Due"
        prop="Balance"
        min-width="90px"
        sortable="custom"
      >
        <template v-slot="{ row }">
          {{ (row.balance / 100) | currency }}
        </template>
      </el-table-column>

      <el-table-column
        label="Status"
        prop="Status"
        min-width="90px"
        sortable="custom"
      >
        <template v-slot="{ row }">
          <div v-if="row.status == 'INACTIVE'">
            <span class="text-muted">Canceled</span>
          </div>
          <div v-if="row.status == 'ACTIVE'">
            <span class="text-success">Active</span>
          </div>
          <div v-if="row.status == 'AWAITINGPATIENT'">
            <span class="text-purple">Awaiting Completion</span>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <b-pagination
      v-if="showPagination"
      align="center"
      class="mt-3"
      v-model="page"
      :total-rows="rows"
      :per-page="perPage"
      @change="pageChange"
    ></b-pagination>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";

export default {
  name: "customerMembershipBilling-search-results",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  props: {
    query: {},
    supressPatientName: false,
  },
  watch: {
    query: {
      immediate: true,
      async handler(newVal) {
        this.page = 1;
        this.bind();
      },
      deep: true,
    },
  },
  data() {
    return {
      rows: null,
      perPage: 10,
      page: 1,
      sort: "Created:Descending",
      paymentPlans: [],
      showPagination: false,
    };
  },
  mounted() {},
  methods: {
    sortChange(a) {
      var self = this;
      self.page = 1;

      if (a.prop && a.order) self.sort = a.prop + ":" + a.order;
      else self.sort = null;

      this.bind();
    },
    pageChange(pg) {
      this.page = pg;
      this.bind();
    },
    handleClick(item) {
      this.$emitter.emit("show-customer-membership-billing", item.id);
    },
    bind() {
      var self = this;

      var form = this.query;

      form.sort = self.sort;
      form.page = self.page;

      if (form.id == "") form.id = null;

      self.$client
        .post("/api/customerMembershipBilling/customerMembershipBillings", form)
        .then((response) => {
          if (response.data.isSuccess) {
            self.paymentPlans = response.data.value;
            self.rows = response.data.value[0].rowCount;
            self.showPagination = self.rows > 10;
          }
        });
    },
  },
};
</script>
<style>
body #paymentPlanTable tr:hover {
  background-color: #f6f9fc;
  cursor: pointer;
}
</style>
